import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { Users } from "lucide-react";

export default function MasterCustomers() {
  return (
    <MasterDataPage
      title="Customers"
      subtitle="Vehicle owners — 360° view of jobs, claims & invoices"
      entity="customers"
      testId="customers"
      icon={Users}
      detailRoute={(r) => `/master/customers/${r.id}`}
      defaultForm={{
        first_name: "", last_name: "", phone: "", email: "", address: "",
        city: "", state: "", zip_code: "", preferred_language: "en",
        insurance_company: "", policy_number: "", sms_opt_in: false, email_opt_in: true, notes: "",
      }}
      fields={[
        { key: "first_name", label: "First Name", required: true },
        { key: "last_name", label: "Last Name", required: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email" },
        { key: "address", label: "Address", span: 2 },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        { key: "zip_code", label: "ZIP" },
        { key: "insurance_company", label: "Insurance Company" },
        { key: "policy_number", label: "Policy #" },
        { key: "preferred_language", label: "Language", type: "select", options: [{ value: "en", label: "English" }, { value: "pt", label: "Português" }, { value: "es", label: "Español" }] },
        { key: "sms_opt_in", label: "SMS Opt-in", type: "checkbox", checkboxLabel: "Customer accepts SMS communication" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Name", render: (r) => `${r.first_name} ${r.last_name}` },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "city", label: "Location", render: (r) => [r.city, r.state].filter(Boolean).join(", ") || "—" },
        { key: "insurance_company", label: "Insurance" },
      ]}
    />
  );
}
